import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
// import { withPrefix } from 'gatsby'
import { useSiteMetadata } from '../custom-hooks/useSiteMetadata'

// TODO: add favicon
interface HeadI {
  title?: string
  description?: string
  author?: string
}
const Head: FC<HeadI> = ({ title, description, author }) => {
  const siteMetadata = useSiteMetadata()
  const { title: siteTitle, description: siteDescription, author: siteAuthor } = siteMetadata

  return (
    <Helmet htmlAttributes={{ lang: 'en' }}>
      <title>{title ?? siteTitle}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={description ?? siteDescription} />
      <meta name="author" content={author ?? siteAuthor} />
      {/* <link rel="shortcut icon" type="image/jpg" href={withPrefix(favicon)} /> */}
    </Helmet>
  )
}
export default Head
